import { FlexColumn, LabeledData, useMoment } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { Cell, Grid } from 'baseui/layout-grid';
import { LabelMedium } from 'baseui/typography';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { LiveStatusDetail } from '../../../types/liveStatus';
import { isBrand, isSubBrand } from '../../../utils/currentStates';

type Props = {
  liveStatusDetail: LiveStatusDetail;
};
function DetailCardBody({ liveStatusDetail }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { formatDateFromTs } = useMoment();
  const labelWidht = '90px';

  return (
    <Block
      className={css({
        padding: theme.sizing.scale600,
      })}
    >
      <Grid
        gridColumns={12}
        gridGaps={[8]}
        gridGutters={[16]}
        gridMargins={[0]}
      >
        <Cell span={[12, 12, 12, 12, 6]}>
          <FlexColumn gap={0}>
            <LabeledData
              label={'Ident'}
              content={liveStatusDetail.ident}
              labelWidth={labelWidht}
            />
            <LabeledData
              label={'Activo ID'}
              content={liveStatusDetail.assetId}
              labelWidth={labelWidht}
            />
            <LabeledData
              label={'Dispositivo ID'}
              content={liveStatusDetail.deviceId}
              labelWidth={labelWidht}
            />
            {liveStatusDetail.userId && (
              <LabeledData
                label={'Usuario ID'}
                content={liveStatusDetail.userId}
                labelWidth={labelWidht}
              />
            )}
            <LabeledData
              label={'Fecha:'}
              content={liveStatusDetail.timestamp ? formatDateFromTs(liveStatusDetail.timestamp) : '-'}
              labelWidth={labelWidht}
            />
            <LabeledData
              label={'Segundos s/c'}
              content={`${liveStatusDetail.timeSince} seg`}
              labelWidth={labelWidht}
            />
            {liveStatusDetail.phoneLabel && (
              <LabeledData
                label={'Etiqueta'}
                content={liveStatusDetail.phoneLabel}
                labelWidth={labelWidht}
              />
            )}
          </FlexColumn>
        </Cell>
        {liveStatusDetail.vehicle && (
          <Cell span={[12, 12, 12, 12, 6]}>
            <FlexColumn gap={0}>
              <LabelMedium margin={'0px 0px 6px'}>Datos del Vehículo</LabelMedium>
              <LabeledData
                label="Placa:"
                content={liveStatusDetail.vehicle.licensePlate ?? '-'}
              />
              <LabeledData
                label="No. Serie:"
                content={liveStatusDetail.vehicle.vin ?? '-'}
              />
              <LabeledData
                label="Marca:"
                content={
                  isBrand(liveStatusDetail.vehicle.brand)
                    ? liveStatusDetail.vehicle.brand.name
                    : liveStatusDetail.vehicle.brand
                }
              />
              <LabeledData
                label="Submarca:"
                content={
                  isSubBrand(liveStatusDetail.vehicle.subBrand)
                    ? liveStatusDetail.vehicle.subBrand.name
                    : liveStatusDetail.vehicle.subBrand
                }
              />
              <LabeledData
                label="Modelo:"
                content={liveStatusDetail.vehicle?.year?.toString() ?? '-'}
              />
            </FlexColumn>
          </Cell>
        )}
      </Grid>
    </Block>
  );
}

export default memo(DetailCardBody);
